module.exports = __webpack_public_path__ + "img/3_177.6102a04e.png";